<template>
  <v-container fluid>
      <material-card
      color="primary"
      title="Ganti Password"
      class="card-wrapper"
      >
      <v-form class="pw" @submit.prevent="postData()">
          <v-alert v-if="showPrompt" type="warning" text dense border="left" class="pw__alert">
            Demi keamanan akun, ganti password Anda terlebih dahulu sebelum melanjutkan.
          </v-alert>
          <v-alert v-if="errorMessagePasswordLama" type="error" text dense border="left" class="pw__alert">
            {{ errorMessage }}
          </v-alert>

          <div class="pw__grid">
            <div class="pw__field">
              <p class="label mb-1">Password lama <span class="pw__req">*</span></p>
              <v-text-field
                dense
                placeholder="Masukkan password lama"
                v-model="formData.oldPassword"
                :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showOldPassword ? 'text' : 'password'"
                autocomplete="current-password"
                required
                outlined
                @input="$v.formData.oldPassword.$touch()"
                @blur="$v.formData.oldPassword.$touch()"
                @click:append="showOldPassword = !showOldPassword"
                :error-messages="oldPasswordErrors"
              />
            </div>

            <div class="pw__field">
              <p class="label mb-1">Password baru <span class="pw__req">*</span></p>
              <v-text-field
                dense
                placeholder="Masukkan password baru"
                v-model="formData.newPassword"
                :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNewPassword ? 'text' : 'password'"
                autocomplete="new-password"
                required
                outlined
                @input="$v.formData.newPassword.$touch()"
                @blur="$v.formData.newPassword.$touch()"
                @click:append="showNewPassword = !showNewPassword"
                @click.right.prevent @copy.prevent @paste.prevent
                :error-messages="newPasswordErrors"
              />
            </div>

            <div class="pw__field">
              <p class="label mb-1">Konfirmasi password baru <span class="pw__req">*</span></p>
              <v-text-field
                dense
                placeholder="Ketik ulang password baru"
                v-model="formData.confirmNewPassword"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showConfirmPassword ? 'text' : 'password'"
                autocomplete="new-password"
                required
                outlined
                @input="$v.formData.confirmNewPassword.$touch()"
                @blur="$v.formData.confirmNewPassword.$touch()"
                @click:append="showConfirmPassword = !showConfirmPassword"
                @click.right.prevent @copy.prevent @paste.prevent
                :error-messages="confirmNewPasswordErrors"
              />
            </div>
              <!-- live checklist of the same rules the validator uses -->
              <ul class="pw__rules" aria-label="Syarat password baru">
                <li v-for="rule in passwordRules" :key="rule.text" :class="{ 'is-met': rule.met }">
                  <v-icon small>{{ rule.met ? 'mdi-check-circle' : 'mdi-circle-outline' }}</v-icon>{{ rule.text }}
                </li>
              </ul>
          </div>

          <p class="pw__note">Setelah password diganti, Anda akan keluar dan perlu masuk kembali.</p>

          <div class="pw__actions">
            <v-btn text @click="cancel()">Batal</v-btn>
            <v-btn type="submit" depressed color="primary">Simpan password</v-btn>
          </div>
        </v-form>
      </material-card>
  </v-container>
</template>

<script>
import { apiServer } from "../../setup-axios";
import { minLength, maxLength, helpers, sameAs, required } from "vuelidate/lib/validators";
export default {
  data: () => ({
    successCreate: null,
    prompt: "",
    showPrompt: false,
    errorMessage: "",
    errorMessagePasswordLama:false,
    file: null,
    formData: {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: ""
    },
    showOldPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
  }),
  validations: {
    formData: {
      oldPassword: {
        required,
        rules: function(value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*+=-_]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        },
        minLength: minLength(8),
        maxLength: maxLength(255)
      },
      newPassword: {
        required,
        rules: function(value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[!@#\$%\^\&*+=._-]+/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        },
        minLength: minLength(10),
        maxLength: maxLength(255)
      },
      confirmNewPassword: {
        required,
        sameAsPassword: sameAs('newPassword')
      },
    }
  },
  computed: {
    passwordRules() {
      const v = this.formData.newPassword || ''
      return [
        { text: 'Minimal 10 karakter', met: v.length >= 10 },
        { text: 'Huruf besar (A-Z)', met: /[A-Z]/.test(v) },
        { text: 'Huruf kecil (a-z)', met: /[a-z]/.test(v) },
        { text: 'Angka (0-9)', met: /[0-9]/.test(v) },
        { text: 'Simbol (! @ # $ % ^ & * + = . _ -)', met: /[!@#$%^&*+=._-]/.test(v) },
      ]
    },
    oldPasswordErrors() {
      const errors = [];
      if (!this.$v.formData.oldPassword.$dirty) return errors;
      !this.$v.formData.oldPassword.required &&
      errors.push("Password Lama harus diisi");
      !this.$v.formData.oldPassword.minLength &&
      errors.push("Password Lama minimal 8 karakter");
      !this.$v.formData.oldPassword.maxLength &&
      errors.push("Password Lama maksimal 255 karakter");
      !this.$v.formData.oldPassword.rules &&
      errors.push("Password Lama harus mengandung huruf kecil dan besar, angka dan simbol");
      
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.formData.newPassword.$dirty) return errors;
      !this.$v.formData.newPassword.required &&
      errors.push("Password Baru harus diisi");
      !this.$v.formData.newPassword.minLength &&
      errors.push("Password Baru minimal 10 karakter");
      !this.$v.formData.newPassword.maxLength &&
      errors.push("Password Baru maksimal 255 karakter");
      !this.$v.formData.newPassword.rules &&
      errors.push("Password Baru harus mengandung huruf kecil dan besar, angka dan simbol");
      
      return errors;
    },
    confirmNewPasswordErrors() {
      const errors = [];
      if (!this.$v.formData.confirmNewPassword.$dirty) return errors;
      !this.$v.formData.confirmNewPassword.required &&
      errors.push("Konfirmasi Password Baru harus diisi");
      !this.$v.formData.confirmNewPassword.sameAsPassword &&
      errors.push("Konfirmasi Password belum sesuai dengan Password Baru");
      
      return errors;
    },
  },
  created() {
    this.prompt = localStorage.getItem("status");
    console.log(this.prompt)
    if (this.prompt !== "ACTIVE") {
      this.showPrompt = true
    }
  },
  methods: {
    postData() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.errorMessagePasswordLama = false
      let createData = new FormData()
      createData.append("Username",JSON.parse(localStorage.getItem("user")).username)
      createData.append("OldPassword",this.formData.oldPassword)
      createData.append("NewPassword",this.formData.newPassword)
      apiServer
          .put("/pengguna/update-password",createData)
          .then(response => {
            console.log("Successfully updated password:")
            console.log(response.data.message)
            this.sendSnackbar("primary",response.data.message)
            this.$store.dispatch("logout")
          }).catch(error => {
            console.log("There was an error:", error); // Logs out the error
            this.errorMessage = error.response.data.message
            this.errorMessagePasswordLama = true
          });
    },
    cancel() {
      this.$router.push('/profil')
    },
    sendSnackbar(color, message) {
    this.$store.dispatch("setSnackbar", {
      snackbarColor: color,
      snackbarText: message,
    });
  },
  }
}
</script>

<style scoped>
/* style.css forces p sizes with !important, so text rules here do too */
.pw {
  max-width: 760px;
}

/* old password on its own row; new + confirmation side by side; rules under both */
.pw__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
}

.pw__grid > .pw__field:first-child {
  grid-column: 1;
}

.pw__grid > .pw__field:nth-child(2) {
  grid-column: 1;
}

.pw__grid > .pw__rules {
  grid-column: 1 / -1;
}

.pw__alert {
  margin-bottom: 20px;
}

/* input details (hints/errors) are hidden app-wide unless invalid, so space the fields here */
.pw__field {
  margin-bottom: 16px;
}

.pw__req {
  color: var(--esign-error);
}

.pw__rules {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 4px 16px;
  margin: -4px 0 16px;
  padding: 0;
  list-style: none;
}

.pw__rules li {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--esign-text-muted);
}

.pw__rules li .v-icon {
  color: var(--esign-border-strong);
}

.pw__rules li.is-met {
  color: var(--esign-success);
}

.pw__rules li.is-met .v-icon {
  color: var(--esign-success);
}

.pw__note {
  margin: 4px 0 0 !important;
  font-size: 13px !important;
  line-height: 19px !important;
  color: var(--esign-text-muted);
}

@media (max-width: 600px) {
  .pw__grid {
    grid-template-columns: 1fr;
  }

  .pw__grid > .pw__field:first-child,
  .pw__grid > .pw__field:nth-child(2) {
    grid-column: auto;
  }
}

.pw__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--esign-border);
}
</style>
